export default {
    domain: 'http://localhost:8000/',
    baseApi: 'http://localhost:8000/api',
};